import {Injectable} from '@angular/core';

@Injectable()
export class PartDisplayService {
  constructor() {
  }

  private partProp(part: any, prop: string): string {
    return part ? part[prop] : null;
  }

  public code(part: any, template: string): string {
    return '';

    // use below if we want to show codes
    // const code = this.partProp(part, 'code');
    // return code ? template.replace(/_/g, code) : '';
  }

  public description(part: any): string {
    return this.partProp(part, 'description');
  }

  public longDescription(part: any): string {
    return this.partProp(part, 'longDescription');
  }
}


